/**
 * Class description
 *
 * Created: 2017-11-17
 * @author jonas
 */

import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/SpineAsset";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TextureAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/TextureAsset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/BitmapFontAsset";

// To extend enum
// declare module "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName" {
//     export enum ResourcesGroupName {
//         GAME_GROUP = "gamegroup"
//     }
// }

// const temp = ResourcesGroupName as any;
// temp["GAME_GROUP"] = "gamegroup";

export class PixiesVsPiratesGameAssets {

    public static INTRO_BACKGROUND:string = "mainBackground";
    public static INTRO_LOGO:string = "logo";

    public static MAIN_GAME_BACKGROUND:string = "mainBackground";
    public static FREESPIN_BACKGROUND:string = "fsBackground";

    public static getSymbolStateTexturePath(symbolName:string, stateName:string | null = null):string {
        if(stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "_" + stateName;
    }

    public static getSymbolStateTextures(symbolName:string, stateName:string | null = null):PIXI.Texture[] {
        return GameResources.getTextures(PixiesVsPiratesGameAssets.getSymbolStateTexturePath(symbolName, stateName));
    }

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [
            {
                name : "fonts",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new BitmapFontAsset("numbersOpenSans800", "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset("numbersWinCountUp", "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset("glowNumbers", "fonts/bitmapfonts/GlowNumbers.fnt"),
                    new BitmapFontAsset("NumbersPopFont", "fonts/bitmapfonts/NumbersPopFont.fnt")
                ]
            },
            {
                name : "intro",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("intro0", "sheets/intro/intro0.json"),
                    new TextureAsset("BattleRoundsIntro", "sheets/introBattleRounds/BattleRoundsIntro.png")
                ],
                animations : {
                    "battleRoundsIntro" : "BattleRoundsIntro",
                    "introLogo" : "introLogo",
                    "introBoard" : "IntroBoard",
                    "mysteryChest" : "mysteryChest",
                    "navArrow" : "NavArrow",
                    "navDot" : "NavDot",
                    "navDotRing" : "NavDotRing",
                    "wildNudgeIntro" : "WildNudgeIntro",
                    "xNudgeLogoIntro" : "XNudgeLogoIntro",
                    "xWaysLogoIntro" : "XwaysLogoIntro",
                    "logo" : "logobanner"
                }
            },
            {
                name : "introJpeg",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("introJpeg0", "sheets/introJpeg/introJpeg0.json")
                ],
                animations : {
                    "mainBackground" : "mainBackground"
                }
            }
        ],

        main : [
            {
                name : "main",
                assets : [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json")
                ],
                animations : {
                    "fsBackground" : "BonusBGHalfSize",
                    "foreground" : "bg/foreground",
                    "reelBg" : "bg/board",
                    "boardFrame" : "bg/boardframe",
                    "boardFrameFS" : "bg/bonusframe",
                    "wheel" : "bg/steeringwheel",
                    "reelDivider" : "reelDividers/DividerLineAnimateIn/lineanimatein_",
                    "waysWonText" : "winways/WaysWonText",
                    "wayWonText" : "winways/WayWonText",
                    "winSwirl" : "win/WinSwirlJPGs/winswirl_",
                    "winGlow" : "win/softglowrays",
                    "bigWinText" : "bigwin/BigWinText/BigWinTextIn_",
                    "megaWinText" : "bigwin/MegaWinText/MegaWin_",
                    "superMegaWinText" : "bigwin/SuperWinText/SuperTextOn_",
                    "bigWinLoop" : "bigwin/BigWinLoop/BigWinLoop25%15fps/BigWinLoop_",
                    "megaWinLoop" : "bigwin/MegaWinLoop/MegaWinLoop25%15FPS/MegaWinLoop_",
                    "bigWinPoof" : "bigwin/BigWinPoof/BigWinPoof25%15FPS/BigWinPoof_",
                    "smallPoof" : "win/SmallPoof/SmallPoof25%/SmallPoof_",
                    "fsIntroBG" : "fsintro/BonusTransitionBG",
                    "fsIntroBGBlur" : "fsintro/bonustransitionbgblur",
                    "waysText" : "winways/WaysText",
                    "reelHighlight" : "effects/ReelHilightAnticipation/anticipationframe_",
                    "radialGlow" : "effects/spine_scatter/still/radial_glow_2",
                    "cloud1" : "bg/Cloud1",
                    "cloud2" : "bg/Cloud2",
                    "cloud3" : "bg/Cloud3",
                    "glowdust" : "fs/glowdust2",
                    "glowdustOffset" : "fs/glowdustOffset",
                    "softparticle" : "fs/softparticle"
                }
            },
            {
                name : "mainHighQuality",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("mainHighQuality0", "sheets/mainHighQuality/mainHighQuality0.json"),
                    new TextureAsset("mainHighQuality1", "sheets/mainHighQuality/mainHighQuality1.json"),
                    new TextureAsset("mainHighQuality2", "sheets/mainHighQuality/mainHighQuality2.json"),
                    new TextureAsset("mainHighQuality3", "sheets/mainHighQuality/mainHighQuality3.json")
                ],
                animations : {
                    "M1_idle" : "M1/M1_idle/M1IdleAnim_",
                    "M2_idle" : "M2/M2_idle/M2IdleAnim_",
                    "pixieBannerIdle" : "fs/banners/PixieIdle_15fps/PixieBannerIdle_",
                    "pixieText" : "fs/banners/PixiesText",
                    "pirateBannerIdle" : "fs/banners/PirateIdle_15fps/PirateBannerIdle_",
                    "pirateText" : "fs/banners/PiratesText",
                    "bannerGlow" : "fsintro/ChosenBannerGlow6FPS/ChosenBannerGlow_",
                    "pixieBranch" : "fs/banners/branch",
                    "pirateBranch" : "fs/banners/boom",
                    "fsIntroTextScroll" : "fs/TextScroll1",
                    "pixieHead" : "fs/meter/PixieQueenHead",
                    "pixieBar" : "fs/meter/PixieBar/pixiebar_",
                    "pirateHead" : "fs/meter/PirateCaptainHead",
                    "pirateBar" : "fs/meter/PirateBar/PirateBar_",
                    "pixieDefeat" : "fs/meter/PixieDefeat",
                    "pirateDefeat" : "fs/meter/PirateDefeat",
                    "barMarker" : "fs/meter/DividerMark",
                    "collector1" : "fs/meter/CollectorGold",
                    "collector2" : "fs/meter/Collector",
                    "picker" : "fs/meter/PickerTriangle",
                    "versusLine" : "fs/meter/VersusLinePortraitHalfSize",
                    "gunShot" : "fs/Gunshot/Gunshot_",
                    "spellHit" : "fs/MagicSpellHit/MagicSpellHit_",
                    "characterHitGlow" : "fs/softhitglow",
                    "pixieOutroDefeat" : "fsOutro/PixiesLose",
                    "pixieOutroWin" : "fsOutro/PixiesWin",
                    "pirateOutroDefeat" : "fsOutro/PiratesLose",
                    "pirateOutroWin" : "fsOutro/PiratesWin",
                    "spinWonTextBanner" : "fsOutro/SpinsWonTextBanner",
                    "battleRoundsText" : "fsOutro/BattleRoundsText",
                    "darkGradient" : "fsOutro/darkGradient",
                }
            },
            {
                name : "spine",
                assets : [
                    new SpineAsset("spin_effect", "spine/spin_effect.json"),
                    new SpineAsset("foreground_anim", "spine/ForegroundAnim.json"),
                    new SpineAsset("L1_bounce", "spine/L1Bounce.json"),
                    new SpineAsset("L2_bounce", "spine/L2Bounce.json"),
                    new SpineAsset("L3_bounce", "spine/L3Bounce.json"),
                    new SpineAsset("L4_bounce", "spine/L4Bounce.json"),
                    new SpineAsset("L5_bounce", "spine/L5Bounce.json"),
                    new SpineAsset("L6_bounce", "spine/L6Bounce.json"),

                    new SpineAsset("M1_bounce", "spine/M1Bounce.json"),
                    new SpineAsset("M2_bounce", "spine/M2Bounce.json"),
                    new SpineAsset("M3_bounce", "spine/M3Bounce.json"),
                    new SpineAsset("M4_bounce", "spine/M4Bounce.json"),
                    new SpineAsset("M5_bounce", "spine/M5Bounce.json"),
                    new SpineAsset("M6_bounce", "spine/M6Bounce.json")
                ]
            },
            {
                name : "symbols",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ],
                animations : {
                    "wildTree_spin" : "W/W_tree_spin",
                    "midSymBg_spin" : "midsymbolframe/background_spin",
                    "midSymFrameSides_spin" : "midsymbolframe/FrameSides_spin",
                    "wildWriteOn_spin" : "W/WildWriteOn_spin",
                    "scatterText_spin" : "S/S_text_spin"
                }
            },
            {
                name : "scatterAnimations",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("scatterAnimations0", "sheets/scatterAnimations/scatterAnimations0.json")
                ],
                animations : {
                    "S_attention" : "S/S_attention/ScatterSkullHit_",
                    "S_idle" : "S/S_idle/ScatterBGLoop_",
                    "S_win" : "S/ScatterFSTrigger/ScatterFSTrigger_"
                }
            },
            {
                name : "eSymbolAnimations",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("eSymbolAnimations0", "sheets/eSymbolAnimations/eSymbolAnimations0.json")
                ],
                animations : {
                    "E_attention" : "E/EAttention/EAttention_",
                    "E_expand" : "E/XWaysSymMagic15fps/xwayssymtransform_"
                }
            },
            {
                name : "wildAnimations",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("wildAnimations0", "sheets/wildAnimations/wildAnimations0.json"),
                    new TextureAsset("wildAnimations1", "sheets/wildAnimations/wildAnimations1.json")
                ],
                animations : {
                    "wildNudgeBg" : "W/W_nudge/wildbgloop__",
                    "wildWriteOn" : "W/WildWriteOn/WildWriteOn_",
                    "wildNudgeSparkles" : "W/WildNudgeSparkles/WildeNudgeSparkles_",
                    "wildMultiplier" : "W/WildMultipliers/w_",
                    "wildMultiplier_spin" : "W/WildMultipliers/w_spin_"
                }
            },
            {
                name : "symbolsHighQuality",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbolsHighQuality0", "sheets/symbolsHighQuality/symbolsHighQuality0.json")
                ],
                animations : {
                    "midSymBg" : "midsymbolframe/background",
                    "midSymFrameTop" : "midsymbolframe/FrameTop",
                    "midSymFrameBottom" : "midsymbolframe/frameBottom",
                    "midSymFrameSides" : "midsymbolframe/FrameSides",
                    "wildTree" : "W/W_tree",
                    "scatterText" : "S/S_text"
                }
            }
        ]
    };
}
